module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-318.11b6a89.woff2";